<template>
  <div>
    <slot/>
    <div v-if="showError || characterLimit" class="flex justify-end text-xs relative font-normal">
      <span v-if="showError"
            class="absolute left-0 text-xs text-focus-error mt-0.5"
            :class="{'pr-10' :characterLimit}"
      >
        {{ errorDescription }}
      </span>
      <character-counter v-if="characterLimit" :count="characterCount" :limit="characterLimit" class="w-full mt-1"/>
    </div>
  </div>
</template>

<script>
import CharacterCounter from '@/components/editor/message/CharacterCounter.vue'
import previewModule from '@/store/modules/preview.module'

export default {
  name: 'WithErrorMessage',

  components: { CharacterCounter },

  props: {
    showError: {
      type: Boolean,
      default: false
    },
    characterLimit: {
      type: Number,
      default: null
    },
    characterCount: {
      type: Number,
      default: null
    }
  },

  computed: {
    errorDescription: previewModule.errorDescription
  }
}
</script>
